import { autoinject } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { EsgIndicators } from "../../tabs/esg-indicators";

@autoinject
export class PrintVesselComparisonDialog {
    model: EsgIndicators;
    refPrintPageEsgIndicators: HTMLElement;

    constructor(private dialogClientService: DialogClientService) { }

    activate(model: EsgIndicators){
        this.model = model;
    }

    close() {
        this.dialogClientService.hide();
    }

    printDocument() {
        $(".document-vessel-comparison").printThis({
            importCSS: true,
            importStyle: true,
            loadCSS: "/styles/core.min.css",
            canvas: true
        });
    }

    get printPageScrollWidth() {

        if(this.refPrintPageEsgIndicators) {

            return this.refPrintPageEsgIndicators.scrollWidth - 20;

        }

    }
}
